import React, { useState } from "react"
import {
  Col,
  Card,
  CardBody,
  Row,
  Nav,
  NavItem,
  NavLink,
  Table,
  Input,
  Label,
  Button
} from "reactstrap"
import { Link } from "react-router-dom"
import classnames from "classnames"
import PropTypes from 'prop-types';
//Simple bar
import SimpleBar from "simplebar-react"

const TotalSellongProduct = props => {
  //const [activeTab, setActiveTab] = useState("1")

  return (
    <React.Fragment>
      <Col xl="12">
      
         <Card>
          <CardBody>
          <h4 className="card-title text-primary mdi mdi-calendar-account mb-4">{" "} Leave Allotments</h4>
              <SimpleBar style={{ maxHeight: "300px" }}>
                <div className="table-responsive">
                  <Table className="table table-nowrap align-middle table-hover mb-0 table table-sm m-0">
                    
                    
                    <thead>
                    <tr>
                      <th>Category</th>
                      <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Entitled</th>
                      <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Taken</th>
                      <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                    {props.leave && props.leave.map((l,k)=>(
                      <tr key={k}>
           
                        <td style={{ width: "90px" }}>
                          <h5 className="text-truncate font-size-13 mb-1">
                              {l.leaveType}
                          </h5>
                        </td>
                        <td style={{verticalAlign: 'middle', textAlign: 'center', width: "50px" }}>
                          <h5 className="text-truncate font-size-13 mb-1">
                            {l.entitled}
                          </h5>
                        </td>
                        <td style={{verticalAlign: 'middle', textAlign: 'center', width: "50px" }}>
                          <h5 className="text-truncate font-size-13 mb-1">
                            {l.used}
                          </h5>
                        </td>
                        <td style={{verticalAlign: 'middle', textAlign: 'center', width: "50px" }}>
                          <h5 className="text-truncate font-size-13 mb-1">
                            {l.balance}
                          </h5>
                        </td>
                      </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </SimpleBar>
          </CardBody>
        </Card>


      </Col>
    </React.Fragment>
  )
}
TotalSellongProduct.propTypes = {
  leave: PropTypes.any,
  showReports: PropTypes.any
}
export default TotalSellongProduct
